import { render, staticRenderFns } from "./toolbar-component.vue?vue&type=template&id=b7dfd812&"
import script from "./toolbar-component.vue?vue&type=script&lang=js&"
export * from "./toolbar-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports